export default __webpack_public_path__ + "static/media/ahmed-almakhzanji-kshkB1i5_5o-unsplash.024ee520.jpg";